import React from "react";
import Link from "gatsby-link";

const getNavItems = () => (
  [
    {
      primaryText: "Home",
      component: Link,
      to: "/"
    },
    {
      primaryText: "Legal Checklist",
      component: Link,
      to: "/legal-checklist"
    },
    {
      primaryText: "Working with Lawyers",
      component: Link,
      to: "/working-with-lawyers"
    },
    {
      primaryText: "Free Events",
      component: Link,
      to: "/events"
    },
    {
      divider: true
    },
    {
      primaryText: "Business Modeling",
      component: Link,
      to: "/business-modeling"
    },
    {
      primaryText: "Entity Formation",
      component: Link,
      to: "/entity-formation"
    },
    {
      primaryText: "Capitalization",
      component: Link,
      to: "/capitalization"
    },
    {
      primaryText: "Operational Relationships",
      component: Link,
      to: "/operational-relationships"
    },
    {
      primaryText: "Managing Risks",
      component: Link,
      to: "/managing-risks"
    },
    {
      primaryText: "Extra Permits and Licenses",
      component: Link,
      to: "/extra-permits-and-licenses"
    },
    {
      divider: true
    },
    {
      primaryText: "About Us",
      component: Link,
      to: "/about-us"
    },
    {
      primaryText: "Donate",
      component: Link,
      to: "/donate"
    }
  ]
)

export default getNavItems;


// WEBPACK FOOTER //
// ./src/components/NavItems.js